import { createSelector } from '@reduxjs/toolkit';
import { reduxEqualityFunction } from 'library/helpers/utility';
import WithHyperLink from 'library/hoc/withHyperLink';
import { useSelector } from 'react-redux';
import { ProfileImageComponent } from 'zComponents/atoms';
import PeopleActionDropdown from 'zComponents/molecules/PeopleActionDropdown';
import { Card, Col, Collapse, Flex, Row, Typography } from 'zui/Antd';
import PeopleAddressPanel from '../PeopleAddressPanel';
import PeopleBookingsPanel from '../PeopleBookingsPanel';
import PeopleContactsPanel from '../PeopleContactsPanel';
import PeopleTeamsComponent from '../PeopleTeamsPanel';

const { Panel } = Collapse;
const { Text, Title } = Typography;

// Selector to get the rooms for the current profile’s orgID
const selectPersonByID = createSelector(
	[(state) => state.People.data, (_, personID) => personID],
	(people, personID) => people.find((person) => person.personID === personID) || {}
);

const ViewProfileCard = ({ personID }) => {
	// Selector to get person by ID
	const person = useSelector((state) => selectPersonByID(state, personID), {
		equalityFn: reduxEqualityFunction
	});

	// Destructure person object
	const { displayName, email, userType } = person;

	// HOC to wrap the entity name with a hyperlink
	const EntityWithLink = WithHyperLink((a) => {
		return a.children;
	});

	return (
		<Card>
			<Row justify='center' align='middle' gutter={[0, 10]}>
				<Col span={24}>
					<Flex justify='center'>
						<ProfileImageComponent entityObject={person} size={150} shape='circle' entityName='People' />
					</Flex>
				</Col>
				<Col span={24} style={{ textAlign: 'center' }}>
					<EntityWithLink type='person' dataID={personID}>
						<Title level={3} style={{ marginTop: 0 }}>
							{displayName}
						</Title>
					</EntityWithLink>
					<Text>{userType?.name || 'N/A'}</Text>
				</Col>
				<Col span={24} style={{ textAlign: 'center' }}>
					<EntityWithLink type='person' dataID={personID}>
						{email?.charAt(0).toUpperCase() + email?.slice(1) + ' | site name '}
					</EntityWithLink>
				</Col>
				<Col span={24} style={{ textAlign: 'center' }}>
					<PeopleActionDropdown
						data={person}
						placement='bottom'
						size='medium'
						shape='circle'
						showIcon={false}
					/>
				</Col>
			</Row>

			<Collapse
				destroyInactivePanel={true}
				expandIconPosition='right'
				ghost
				defaultActiveKey={['1', '2', '3', '4']}
			>
				<Panel header='Teams' key='1'>
					<PeopleTeamsComponent personID={personID} />
				</Panel>
				<Panel header='Addresses' key='2'>
					<PeopleAddressPanel personID={personID} />
				</Panel>
				<Panel header='Bookings' key='3'>
					<PeopleBookingsPanel personID={personID} />
				</Panel>
				<Panel header='Contacts' key='4'>
					<PeopleContactsPanel personID={personID} />
				</Panel>
			</Collapse>
			{/* <IndividualDeviceInformationModal
				visible={deviceModalVisible}
				setVisible={setDeviceModalVisible}
				data={{
					deviceID: Number(selectedDevice.uID)
				}}
			/> */}
		</Card>
	);
};

export default ViewProfileCard;
